import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import { ConsentIndexResource, ConsentSaveRequest, ConsentUpdateResource } from "../types/consent";

const baseKey = "consents";
export const consentService = {
	...withIndexEndpoint<ConsentIndexResource>([baseKey]),
	...withShowEndpoint<ConsentUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<ConsentSaveRequest>([baseKey]),
	...withUpdateEndpoint<ConsentSaveRequest>([baseKey]),
	...withOptionsEndpoint<ConsentIndexResource>([baseKey]),
};
